<template>
  <div class="d-flex flex-column">
    <a-col v-if="multiple">
      <a-row style="margin-bottom: 15px" type="flex">
        <a-button
          :disabled="isListHasCheckedItem"
          style="margin-bottom: 10px; margin-right: 10px"
          @click="deselectChecked"
        >
          Снять выделенные
        </a-button>
        <a-popconfirm
          :class="{ disabled: isListHasCheckedItem }"
          title="Вы действительно хотите удалить выбранные файли?"
          @confirm="deleteSelected"
        >
          <a-button
            :disabled="isListHasCheckedItem"
            style="margin-bottom: 10px; margin-right: 10px"
          >
            Удалить выделенные
          </a-button>
        </a-popconfirm>
        <a-popconfirm
          :class="{ disabled: !files.length }"
          title="Вы действительно хотите удалить вcе файли?"
          @confirm="deleteAll"
        >
          <a-button :disabled="!files.length" style="margin-bottom: 10px">
            Удалить все
          </a-button>
        </a-popconfirm>
      </a-row>
    </a-col>
    <div class="ant-upload-list ant-upload-list-picture-card">
      <!-- pictures to upload -->
      <draggable
        v-model="files"
        handle=".dd-move-btn"
        v-bind="dragOptions"
        @end="emitDragChange"
      >
        <div
          v-for="(item, index) in files"
          :key="index"
          class="ant-upload-list-item dd-item-cursor fade-in"
        >
          <div class="ant-upload-list-item-info">
            <span style="height: 100%">
              <a
                class="ant-upload-list-item-thumbnail"
                href="#"
                rel="noopener noreferrer"
                target="_blank"
              >
                <img
                  v-if="typeof item.fileTarget === 'object'"
                  :alt="item.name"
                  :src="toBlob(item.fileTarget)"
                />

                <img
                  v-else
                  :alt="filesUrl + item.file"
                  :src="filesUrl + item.file"
                />
              </a>
              <span :title="item.name" class="ant-upload-list-item-name">
                {{ item.name }}
              </span>
            </span>
          </div>
          <a-row
            class="ant-upload-list-item-actions upload-actions-block"
            type="flex"
          >
            <div
              v-show="multiple"
              class="antd-upload-action-item__custom dd-move-btn"
            >
              <a-icon type="drag" />
            </div>

            <div
              v-show="multiple"
              :key="Math.random().toString().slice(2)"
              :class="[
                'antd-upload-action-item__custom',
                { primary: selectedImage == item.uzid }
              ]"
              @click="selectImage(item.uzid)"
            >
              <a-icon type="arrow-up" />
            </div>
            <div
              class="antd-upload-action-item__custom"
              @click="imageIndex = index"
            >
              <a-icon type="eye" />
            </div>

            <a-popconfirm
              :disabled="!files.length"
              title="Вы действительно хотите удалить?"
              @confirm="removeItem(item, index)"
            >
              <div class="antd-upload-action-item__custom">
                <a-icon type="delete" />
              </div>
            </a-popconfirm>
          </a-row>

          <a-checkbox
            v-if="multiple"
            :checked="item.checked"
            class="list-item__checkbox"
            @click.prevent="item.checked = !item.checked"
          />
          <!-- <div>{{ item.is_main }} {{ item.id }} {{ item.position }}</div> -->
        </div>
      </draggable>
    </div>
    <osg-cropper
      v-if="withCropper && showForm"
      v-model="showForm"
      :ratio-width="16"
      :quality="0.9"
      :ratio-height="9"
      @onImageSelected="setImageExtention"
      @onSetImage="getImage"
    />
    <!-- <a-button type="primary" @click="showModal(true)">Open Modal with async logic</a-button> -->
    <!-- v-if="multiple || files == 0" -->
    <div class="ant-upload ant-upload-select ant-upload-select-picture-card">
      <!-- @click="$refs.fileRef.click()" -->
      <span
        class="ant-upload ant-upload-btn"
        role="button"
        tabindex="0"
        @click="showModal(true)"
      >
        <input
          ref="fileRef"
          accept="image/jpeg, image/png"
          style="display: none"
          type="file"
          v-bind="$attrs"
          @change="fileInputHandler"
        />

        <div>
          <i class="anticon anticon-plus">
            <svg
              aria-hidden="true"
              class
              data-icon="plus"
              fill="currentColor"
              focusable="false"
              height="1em"
              viewBox="64 64 896 896"
              width="1em"
            >
              <path
                d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
              />
              <path
                d="M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z"
              />
            </svg>
          </i>
          <div class="ant-upload-text">Выбрать</div>
        </div>
      </span>
    </div>

    <!-- <a-button style="margin-top: 25px" type="primary" @click="mergeFiles">Merge</a-button> -->

    <!-- <ul>
      <li
        v-for="(file,index) in files"
        :key="index"
      >{{index}} {{file.name || file.file}} : {{file.checked}}</li>
    </ul>-->

    <CoolLightBox
      :items="listForPreview"
      :index="imageIndex"
      :full-screen="true"
      @close="imageIndex = null"
    />
  </div>
</template>

<script>
import draggable from "vuedraggable"
import CoolLightBox from "vue-cool-lightbox"
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css"

export default {
  components: {
    CoolLightBox,
    "osg-cropper": () => import("@/components/imageCrop/modalCrop"),
    draggable
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    selectedImage: {
      type: String,
      default: () => ""
    },
    methodName: {
      type: String,
      default: () => "news"
    },

    multiple: {
      type: Boolean,
      default: true
    },

    withCropper: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      fileExtension: "jpeg",
      showForm: false,
      files: [],
      imageIndex: null,
      listForPreview: []
    }
  },
  computed: {
    isListHasCheckedItem() {
      return !this.files.some((item) => item.checked)
    }
  },

  watch: {
    list: {
      handler: "rebaseImages",
      immediate: true
    }
  },

  // watch: {
  //   files() {
  //     this.emitDragChange();
  //   }
  // },
  // mounted() {},
  beforeMount() {
    this.setlistForPreview()
  },
  methods: {
    rebaseImages() {
      const list1 =
        (this.list &&
          this.list.map((item) => ({
            ...item,
            checked: false,
            uzid: Math.random().toString().slice(2)
          }))) ||
        []
      const list2 = this.files.map((item) => ({
        ...item,
        checked: false,
        uzid: Math.random().toString().slice(2)
      }))
      this.files = [...list1, ...list2]

      this.files.forEach((item) => {
        if (item.is_main) {
          this.selectImage(item.uzid)
        }
      })

      this.files = this.files.slice().sort((a, b) => {
        if (a.is_main || !a.position || a.position < b.position) {
          return -1
        }

        if (a.position > b.position) {
          return 1
        }

        return 0
      })
    },
    setlistForPreview() {
      this.listForPreview = []
      // console.log('list', this.list);
      this.list &&
        this.list.forEach((item, index) => {
          this.getMeta({ index, item })
        })
    },
    formatBytes(a, b) {
      if (a === 0) return "0 Bytes"
      const c = 1024
      const d = b || 2

      const e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

      const f = Math.floor(Math.log(a) / Math.log(c))

      const size = {
        // eslint-disable-next-line
        Num: parseFloat((a / Math.pow(c, f)).toFixed(d)),
        Type: e[f]
      }
      // return ${parseFloat((a / Math.pow(c, f)).toFixed(d))} ${e[f]};
      return size
    },
    async getMeta({ index, item }) {
      let img = new Image()
      const vm = this
      const fileSIze = vm.formatBytes(item.size, 0)

      const fileUrlOrRAW =
        "fileTarget" in item
          ? URL.createObjectURL(item.fileTarget)
          : vm.filesUrl + item.file

      // console.log(
      //   'fileUrlOrRAW',
      //   fileUrlOrRAW
      // );

      img.onload = function () {
        vm.listForPreview[index] = {
          src: fileUrlOrRAW,
          title: `Размер изображения: ${fileSIze.Num} ${fileSIze.Type}, высота ${this.width}px x ширина ${this.height}px`
        }

        // return({
        //   width: this.width,
        //   height: this.height
        // });
      }

      img.src = fileUrlOrRAW
      return img
    },
    setImageExtention(e) {
      this.fileExtension = e
    },
    showModal(value) {
      if (this.withCropper) this.showForm = value
      else {
        this.$refs.fileRef.click()
      }
    },
    emitDragChange() {
      // console.log(arg);
      this.$emit("change", this.files)
      setTimeout(() => this.$emit("drag-update"), 1000)
    },
    deleteAll() {
      let promises = []
      this.files.forEach((file) => {
        if (file.id) {
          promises.push(this.$api.delete("/news/file/delete/" + file.id))
        }
      })

      Promise.all(promises)
        .then(() => {
          // console.log(res);
        })
        .then(() => {
          this.files = []
          this.selectImage("")
        })
    },
    deleteSelected() {
      let promises = []
      let noError = true

      const notCheckedFiles = this.files.slice().filter((item) => !item.checked)

      this.files.forEach((file) => {
        if (file.id && file.checked) {
          let promise = this.$api.delete("/news/file/delete/" + file.id)
          promises.push(promise)
        }
      })

      Promise.all(promises)
        .then(
          () => {
            // console.log("res", res);
          },
          () => {
            // console.log("err", err);
            noError = false
            this.$message.error("Ошибка при удалении файла")
          }
        )
        .then(() => {
          this.selectImage("")
          if (noError) {
            this.files = notCheckedFiles
          }
        })
    },
    deselectChecked() {
      this.files.forEach((item) => {
        if (item.checked) {
          item.checked = false
        }
      })
    },
    getImage(variable) {
      this.urltoFile(
        variable,
        this.fileExtension,
        `image/${this.fileExtension}`
      ).then((file) => {
        if (this.multiple) {
          this.$set(this, "files", [
            ...this.files,
            {
              fileTarget: file,
              checked: false,
              uzid: Math.random().toString().slice(2)
            }
          ])
        } else {
          this.$set(this, "files", [
            {
              fileTarget: file,
              checked: false,
              uzid: Math.random().toString().slice(2)
            }
          ])
        }
        // this.$set(this, "files", [
        //         {
        //           fileTarget: file,
        //           checked: false,
        //           uzid: Math.random()
        //             .toString()
        //             .slice(2)
        //         }
        //       ]);

        this.$emit("change", this.files)
      })
    },
    fileInputHandler(event) {
      if (event && event.target.files) {
        for (const key in event.target.files) {
          // eslint-disable-next-line no-prototype-builtins
          if (event.target.files.hasOwnProperty(key)) {
            const element = event.target.files[key]

            // if key not equal to length
            if (!isNaN(key)) {
              if (this.multiple) {
                this.$set(this, "files", [
                  ...this.files,
                  {
                    fileTarget: element,
                    checked: false,
                    uzid: Math.random().toString().slice(2)
                  }
                ])
              } else {
                this.$set(this, "files", [
                  {
                    fileTarget: element,
                    checked: false,
                    uzid: Math.random().toString().slice(2)
                  }
                ])
              }
            }
          }
        }

        this.$emit("change", this.files)
      }

      this.$refs.fileRef.value = null
    },
    toBlob(file) {
      if (file) {
        return URL.createObjectURL(file)
      }
    },
    removeItem(listItem, itemIndex) {
      if (listItem.id) {
        this.$api
          .delete(`/${this.methodName}/file/delete/` + listItem.id)
          .then((res) => {
            if (res.status == 204) {
              this.files.splice(itemIndex, 1)
            }
          })
          .catch((err) => {
            console.error(err)
          })
        return
      }
      this.files.splice(itemIndex, 1)
    },
    urltoFile(url, filename, mimeType) {
      // console.log(url, filename, mimeType)
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer()
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType })
        })
    },
    selectImage(img) {
      // this.selectedImage = this.selectedImage == img ? '' : img;
      // console.log("selectImage");

      if (img) {
        this.files.forEach((item) => (item.is_main = item.uzid == img))
      }

      this.$emit("change", this.files)
      this.$emit("set-main-image", img)
    }
  }
}
</script>
